/**
 * @desc 列表
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<Array<defs.appCenter.ApiInfoResponseDto>>;
export function request(params: API.appCenter.api.list.Params, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/api/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
